import { Add } from '@mui/icons-material';
import { RankingType } from '@on3/api';
import { On3IconTransferRating } from '@on3/icons';
import { Link } from '@on3/ui-lib/components/Link';
import { type ServiceType } from '@on3/ui-lib/components/ServiceLogo/ServiceLogo';
import { slugify } from '@on3/ui-lib/utils/slugify';
import clsx from 'clsx';

import { Stars } from '../Stars';
import styles from './StarRating.module.scss';

interface StarsProps {
  service?: ServiceType;
  stars?: number | null;
  className?: string;
  type?: RankingType;
  fiveStarPlus?: boolean;
  sport?: string | null;
  href?: string;
  rating?: number | null;
  year?: number | string | null;
  round?: number;
}

export const StarRating = ({
  service,
  stars,
  sport,
  fiveStarPlus,
  rating,
  year,
  href,
  type,
  round = 2,
  className,
}: StarsProps) => {
  const sluggedSport = slugify(sport || 'football');
  const fiveStarPlusLinkCheck = fiveStarPlus && year && sluggedSport;
  const fiveStarPlusLink = `/rivals/rankings/industry-five-stars/${sluggedSport}/${year}/`;
  const hasDecimal = (rating || 0) % 1 !== 0;
  const formattedRating =
    service === 'rivals'
      ? rating?.toFixed(1)
      : hasDecimal && rating
        ? rating.toFixed(round)
        : rating;

  return (
    <div className={clsx(styles.block, className)} data-ui="player-star-rating">
      <Link className={styles.stars} data-ui="player-stars" href={href}>
        <Stars stars={stars} />
      </Link>
      {fiveStarPlusLinkCheck && (
        <Link
          className={styles.fiveStar}
          data-ui="five-star-plus-icon"
          href={fiveStarPlusLink}
        >
          <Add />
        </Link>
      )}
      {formattedRating && (
        <span className={styles.rating} data-ui="player-rating">
          {formattedRating}
        </span>
      )}
      {type === RankingType.TransferPortal && (
        <span className={styles.transferPortal} data-ui="transfer-icon">
          <On3IconTransferRating />
        </span>
      )}
    </div>
  );
};
